import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut } from "lucide-react";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAF9F6] text-[#2C2A29]">
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-[#FAF9F6]/80 border-b border-[#E6E2DD]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
          <Link to="/" data-testid="header-logo" className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-[#C86B5E] flex items-center justify-center">
              <span className="font-heading text-white text-xl">cp</span>
            </div>
            <div className="flex flex-col leading-tight">
              <span className="font-heading text-xl tracking-tight">Classes Prénuptiales</span>
              <span className="text-[10px] tracking-[0.25em] uppercase text-[#8A8480]">Le parcours d'avant-mariage</span>
            </div>
          </Link>
          {user && (
            <div className="flex items-center gap-4">
              <span className="hidden sm:block text-sm text-[#5C5754]" data-testid="header-username">
                {user.name}
              </span>
              <button
                onClick={() => {
                  logout();
                  nav("/");
                }}
                data-testid="logout-button"
                className="flex items-center gap-2 text-sm text-[#5C5754] hover:text-[#C86B5E] transition-colors"
              >
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:inline">Déconnexion</span>
              </button>
            </div>
          )}
        </div>
      </header>
      <main>{children}</main>
      <footer className="border-t border-[#E6E2DD] mt-24 py-10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 text-center text-sm text-[#8A8480]">
          <p className="font-heading italic text-base">
            « Ainsi ils ne sont plus deux, mais ils ne font qu'un. »
          </p>
          <p className="mt-2 text-xs tracking-wider uppercase">Matthieu 19:6</p>
        </div>
      </footer>
    </div>
  );
}
